export default {
  getUserByIdRequest(state) {
    state.loading = true
  },
  getUserByIdSuccess(state, data) {
    state.loading = false
    state.admin.user = data
  },
  getUserByIdFailure(state) {
    state.loading = false
  },
  loginRequest (state) {
    state.loading = true
    state.admin = null
  },
  loginSuccess (state, data) {
    state.loading = false
    state.admin = {
      session_key: data.session_key,
      school_year: data.school_year,
      user: data.user
    }
  },
  loginFailure (state) {
    state.loading = false
    state.admin = null
  },
  logoutRequest (state) {
    state.loading = true
  },
  logoutSuccess (state) {
    state.loading = false
    state.admin = null
  },
  logoutFailure (state) {
    state.loading = false
    state.admin = null
  },
  changePasswordRequest(state) {
    state.loading = true
  },
  changePasswordSuccess(state) {
    state.loading = false
  },
  changePasswordFailure(state) {
    state.loading = false
    state.admin = null
  },
  updateUserRequest(state) {
    state.loading = true
  },
  updateUserSuccess(state, data) {
    state.loading = false
    state.admin.user = data
  },
  updateUserFailure(state) {
    state.loading = false
  },
  forgotPasswordRequest(state) {
    state.loading = true;
  },
  forgotPasswordSuccess(state) {
    state.loading = false;
  },
  forgotPasswordFailure(state) {
    state.loading = false;
  },
  passwordResetConfirmRequest(state) {
    state.loading = true;
  },
  passwordResetConfirmSuccess(state) {
    state.loading = false;
  },
  passwordResetConfirmFailure(state) {
    state.loading = false;
  },

  sendBulkMessageRequest(state) {
    // state.loading = true
  },
  sendBulkMessageSuccess(state, data) {
    // state.loading = false
    // state.message = {
    //   selectedGradeLevels: data.selectedGradeLevels,
    //   message: data.message
    // }
  },
  sendBulkMessageFailure(state) {
    // state.loading = false
  },

  testSendBulkMessageRequest(state) {
    // state.loading = true
  },
  testSendBulkMessageSuccess(state, data) {
    // state.loading = false
    // state.message = {
    //   testSendNumbers: data.testSendNumbers,
    //   testMessage: data.testMessage
    // }
  },
  testSendBulkMessageFailure(state) {
    // state.loading = false
  },

  getRecipientsRequest(state) {
    state.loading = true
  },
  getRecipientsSuccess(state, data) {
    state.loading = false
  },
  getRecipientsFailure(state) {
    state.loading = false
  },
  getItexMoStatusRequest(state) {
    state.loading = true
  },
  getItexMoStatusSuccess(state, data) {
    state.loading = false
  },
  getItexMoStatusFailure(state) {
    state.loading = false
  },
  getOutgoingMessagesRequest(state) {
    state.loading = true
  },
  getOutgoingMessagesSuccess(state, data) {
    state.loading = false
  },
  getOutgoingMessagesFailure(state) {
    state.loading = false
  },

  getSMSHistoryRequest(state) {
    state.loading = true
  },
  getSMSHistorySuccess(state, data) {
    state.loading = false
  },
  getSMSHistoryFailure(state) {
    state.loading = false
  },
}
